export default __webpack_public_path__ + "static/media/NoData.dc0765ae.png";